<template>
  <form-group>
    <v-row>
      <v-col cols="9">
        <search-filter
          v-model="document"
          label="Documento do cliente"
        />
      </v-col>
      <v-col cols="3">
        <v-btn
          color="primary"
          :disabled="disabled"
          :loading="loading"
          @click="search()"
        >
          <v-icon>
            md-magnify
          </v-icon>
          Pesquisar
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      v-if="payload.name"
      justify="start"
    >
      <v-col cols="9">
        <input-text
          id="input:name"
          v-model="payload.name"
          label="Nome pesquisado"
          disabled
        />
      </v-col>
    </v-row>
    <v-row v-if="isCsnu">
      <v-col cols="12">
        <csnu-list
          v-model="payload.similarRecords"
          :loading="loading"
        />
      </v-col>
    </v-row>
    <v-row v-if="isOfc">
      <v-col cols="12">
        <ofac-list
          v-model="payload.similarRecords"
          :loading="loading"
        />
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import ShortlistRequest from 'Modules/contacard/shortlist/ShortlistRequest';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import SearchFilter from '@/app/arch/components/crud/components/SearchFilter.vue';
import CsnuList from 'Modules/contacard/shortlist/components/CsnuList.vue';
import OfacList from './components/OfacList.vue';

export default {
  name: 'ShortSearchList',
  components: {
    FormGroup, SearchFilter, CsnuList, OfacList,
  },
  mixins: [ServiceMixin],
  data: () => ({
    requestClass: ShortlistRequest,
    loading: false,
    document: '',
    config: {
      errorMessage: 'Falha ao consultar nome do usuário!',
      showSuccessSwal: false,
    },
    payload: {
      similarRecords: [],
      name: '',
    },
  }),
  computed: {
    disabled() {
      const { length } = this.document;
      return !(length >= 11 && length <= 16);
    },
    getPath() {
      return this.$route.path;
    },
    proxyRequest() {
      if (this.isOfc) {
        return (document) => this.requestClass.searchOfac(document);
      }
      if (this.isPath('csnu')) {
        return (document) => this.requestClass.searchCsnu(document);
      }
      return () => Promise.resolve({});
    },
    isPath() {
      return (path) => String(this.getPath)
        .toLowerCase().includes(
          String(path).toLowerCase(),
        );
    },
    isOfc() {
      return this.isPath('ofac');
    },
    isCsnu() {
      return this.isPath('csnu');
    },
    prepareDocument() {
      return this.document.replace(/[^0-9]/g, '');
    },
  },
  methods: {
    search() {
      this.handleLoading();
      this.makeRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeRequest() {
      this.callService(
        this.proxyRequest(
          this.prepareDocument,
        ),
        this.setPayload,
        this.config,
      );
    },
    setPayload(response) {
      this.handleLoading();
      if (this.hasData(response)) {
        this.payload = response.data;
      }
    },
  },
};
</script>
